interface Action {
  payload: Record<any, any>;
  type: string;
}

export default (state: any, action: Action) => {
  switch (action.type) {
    case "SET_USER":
      localStorage.setItem("token", action.payload.token);
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
        isLoading: false,
      };
    case "LOG_OUT":
      localStorage.removeItem("token");
      return {
        ...action.payload,
      };
    default:
      return state;
  }
};
